// pretendard 폰트는 shared/assets/fonts 로 이관됨. 하위호환 re-export.
export { pretendard } from '@/shared/assets/fonts'
